module.exports = "<div [ngClass]=\"{ 'visible': show }\" class=\"modal\">\n  <div class=\"modal-box\">\n    <ng-content></ng-content>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal/modal.component.html
// module id = ./src/app/shared/components/modal/modal.component.html
// module chunks = main